export default {
  home: {
    title: 'TAXI COLLECTIF ',
    subTitle: 'FAITES VOTRE RÉSERVATION MAINTENANT',
    suppliers: {
      EXO: 'RÉSERVER VOTRE TAXI MAINTENANT',
      STL: 'RÉSERVER VOTRE TAXI MAINTENANT',
    }
  }
};